let shippingCountry = document.getElementById('AddressCountry_Shipping'),
    countryState = document.getElementById('AddressProvince_shipping'),
    shippingCountryZip = document.getElementById('ShippingAddressZip'),
    shippingRatePackage = document.querySelector('.shipping_rate_package'),
    shippingAddressWrapper = document.querySelector('.shipping_rate_message'),
    shippingAddressCount = document.querySelector('.shipping_address_count'),
    item = document.querySelector('.shipping_calc_save'),
    countrySelectsShipping = document.querySelectorAll('data-address-country-select');

if (Shopify && Shopify.CountryProvinceSelector) {
  new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
    hideElement: 'AddressProvinceContainerNewShiping'
  });
}

/**
 * Re-fetches the cart items and footer sections from the server and updates
 * the DOM so that line item indexes in data-index attributes are always in
 * sync with the server-side cart.
 *
 * Shopify's /cart/shipping_rates.json endpoint has a server-side side effect:
 * it associates the queried shipping address with the current cart session.
 * When an unsupported/restricted country is submitted, Shopify can invalidate
 * or reorder cart line items on the server. If the DOM still holds the old
 * (now stale) line indexes, the next cart remove/update call will return
 * "line parameter is invalid" because the index no longer matches.
 *
 * Calling this after every shipping rate query ensures the DOM reflects the
 * current server cart state before the customer interacts with it again.
 */
function refreshCartSections() {
  const cartItemsEl = document.getElementById('main-cart-items');
  const cartFooterEl = document.getElementById('main-cart-footer');
  if (!cartItemsEl) return;

  const cartItemsSectionId = cartItemsEl.dataset.id;
  const cartFooterSectionId = cartFooterEl ? cartFooterEl.dataset.id : null;

  const sectionsParam = [cartItemsSectionId, cartFooterSectionId]
    .filter(Boolean)
    .map((id) => `section_id[]=${encodeURIComponent(id)}`)
    .join('&');

  fetch(`${window.location.pathname}?${sectionsParam}`)
    .then((r) => r.text())
    .then((html) => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      // Re-render cart items (.js-contents holds the table with data-index attrs)
      const liveContents = cartItemsEl.querySelector('.js-contents');
      const parsedContents = parsed.getElementById(cartItemsSectionId)
        ? parsed.getElementById(cartItemsSectionId).querySelector('.js-contents')
        : null;
      if (liveContents && parsedContents) {
        liveContents.innerHTML = parsedContents.innerHTML;
      }

      // Re-render cart footer .js-contents (subtotal/checkout buttons)
      if (cartFooterEl && cartFooterSectionId) {
        const liveFooter = cartFooterEl.querySelector('.js-contents');
        const parsedFooter = parsed.getElementById(cartFooterSectionId)
          ? parsed.getElementById(cartFooterSectionId).querySelector('.js-contents')
          : null;
        if (liveFooter && parsedFooter) {
          liveFooter.innerHTML = parsedFooter.innerHTML;
        }
      }
    })
    .catch(() => {
      // Non-critical: if the refresh fails the page is still usable.
      // The customer can refresh manually if they see a line-invalid error.
    });
}

item.addEventListener('click', () => {
  shippingRatePackage.innerHTML = '';
  if (shippingCountry.value !== "---") {
    item.classList.add('loading');
    fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw `${window.shipping.wrong_message}`;
        }
      })
      .then((response) => {
        item.classList.remove('loading');

        shippingAddressWrapper.classList.remove('no-js-inline');
        shippingAddressCount.innerText = `${response.shipping_rates.length}`;
        response.shipping_rates.forEach((rate) => {
          let text = document.createElement('p');
          text.setAttribute('class', 'mb-0');
          text.innerText = `${rate.name}: ${shopCurrencySymbol}${rate.price}`;
          shippingRatePackage.appendChild(text);
        });
      })
      .catch((e) => {
        item.classList.remove('loading');
        shippingAddressWrapper.classList.add('no-js-inline');
        shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
      })
      .finally(() => {
        // Always refresh cart DOM after a shipping rate query so that line
        // item indexes stay in sync with the server cart state. This prevents
        // "line parameter is invalid" errors on the next remove/update action
        // when Shopify has modified the cart session as a side effect of the
        // shipping_rates.json call (e.g. unsupported/restricted country).
        refreshCartSections();
      });
  } else {
    shippingAddressWrapper.classList.add('no-js-inline');
    shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
  }
});